import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getLocalizedBlockId } from 'lib/localization';
import { update } from 'entities/step-children/actions';
import { ContentShape } from 'entities/step-children/shape';
import BlockShape from 'entities/block/shape';
import { selectActiveLocale } from 'entities/locales/reducer';
import CompiledThemeShape from 'entities/compiled-theme/shape';
import { CONTENT, SURVEY, BLOCK_CATEGORIES } from 'lib/block/block';
import { updateElement } from 'lib/block/block-handler';
import { stripThemeStyles } from 'lib/themes/themes';
import BlockScheme from 'components/BlockScheme';
import ContentSettings from 'components/SideBarSettings/Content';
import SurveySettings from 'components/SideBarSettings/Survey';

export function BlockSettings({
  selectedStepChild,
  blockSettings,
  blockSettingsWithVariations,
  content,
  compiledTheme,
  localeId,
  onUpdate,
}) {
  const { blockCategory, ...blockProperties } = blockSettings;
  const {
    blockCategory: originalBlockCategory,
    ...blockPropertiesWithVariations
  } = blockSettingsWithVariations;

  const handleUpdate = ({
    blockId,
    contentChunk,
    useOriginalId = false,
    replace = false,
  }) => {
    const localizedId = useOriginalId
      ? blockId
      : getLocalizedBlockId({ blockId, localeId });

    const updatedContent = updateElement({
      content,
      blockId: localizedId,
      contentChunk,
      replace,
    });

    onUpdate(
      selectedStepChild,
      stripThemeStyles(compiledTheme, updatedContent)
    );
  };

  return (
    <>
      {BLOCK_CATEGORIES[CONTENT].includes(blockCategory) && (
        <ContentSettings
          blockProperties={blockProperties}
          blockPropertiesWithVariations={blockPropertiesWithVariations}
          handleUpdate={handleUpdate}
        />
      )}
      {BLOCK_CATEGORIES[SURVEY].includes(blockCategory) && (
        <SurveySettings
          blockProperties={blockProperties}
          blockPropertiesWithVariations={blockPropertiesWithVariations}
          localeId={localeId}
          handleUpdate={handleUpdate}
        />
      )}
      <BlockScheme blockProperties={blockProperties} />
    </>
  );
}

BlockSettings.propTypes = {
  selectedStepChild: PropTypes.string,
  blockSettings: BlockShape,
  blockSettingsWithVariations: BlockShape,
  content: ContentShape,
  compiledTheme: CompiledThemeShape,
  localeId: PropTypes.string,
  onUpdate: PropTypes.func,
};
const mapStateToProps = state => {
  const { id: localeId } = selectActiveLocale(state) ?? {};
  return {
    localeId,
  };
};
const mapDispatchToProps = {
  onUpdate: update,
};

export default connect(mapStateToProps, mapDispatchToProps)(BlockSettings);
